import { render, staticRenderFns } from "./ShowLoyalty.vue?vue&type=template&id=2665e7da"
import script from "./ShowLoyalty.vue?vue&type=script&lang=js"
export * from "./ShowLoyalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports